<script setup>
// Placeholder "EM DESENVOLVIMENTO" para telas ainda não liberadas na demonstração.
// Substitui o componente real na rota, então a tela real NUNCA monta (nenhuma
// chamada de API, nada é exposto). Mostra um fundo faux desfocado + overlay central.
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const titulo = computed(() => route.meta?.emBreveTitulo || '');
</script>

<template>
  <div class="relative flex-1 w-full min-h-[70vh] overflow-hidden">
    <!-- fundo faux (desfocado, decorativo — sem dado real) -->
    <div
      aria-hidden="true"
      class="absolute inset-0 p-8 opacity-60 pointer-events-none select-none blur-md"
    >
      <div class="grid grid-cols-3 gap-4 mb-6">
        <div class="h-24 bg-n-slate-3 rounded-xl" />
        <div class="h-24 bg-n-slate-3 rounded-xl" />
        <div class="h-24 bg-n-slate-3 rounded-xl" />
      </div>
      <div class="mb-4 h-60 bg-n-slate-3 rounded-xl" />
      <div class="h-40 bg-n-slate-3 rounded-xl" />
    </div>

    <!-- overlay central -->
    <div
      class="absolute inset-0 flex flex-col items-center justify-center px-6 text-center"
    >
      <div class="mb-4 text-5xl leading-none">🚧</div>
      <span
        class="inline-block px-3 py-1 mb-3 text-xs font-bold tracking-widest uppercase rounded-full text-amber-700 bg-amber-100 dark:text-amber-200 dark:bg-amber-900/40"
      >
        Em desenvolvimento
      </span>
      <h2 v-if="titulo" class="text-2xl font-bold text-n-slate-12">
        {{ titulo }}
      </h2>
      <p class="max-w-md mt-2 text-sm text-n-slate-11">
        Esta área está sendo calibrada e estará disponível em breve.
      </p>
    </div>
  </div>
</template>
